import { render, staticRenderFns } from "./tacticsList.vue?vue&type=template&id=800bae08&scoped=true"
import script from "./tacticsList.vue?vue&type=script&lang=js"
export * from "./tacticsList.vue?vue&type=script&lang=js"
import style0 from "./tacticsList.vue?vue&type=style&index=0&id=800bae08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "800bae08",
  null
  
)

export default component.exports